import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import MiniImage from './MiniImage';
import ApiService from '../../services/ApiService';
import LoadingPage from '../LoadingPage';
import config from '../../config';
import { hasThumbnail } from '../../util/fileTypeImages';

const MiniGallery = ({ itemName, itemId }) => {
  const [loading, setLoading] = useState(true);
  const [spotlight, setSpotlight] = useState({});
  const [attachments, setAttachments] = useState([]);

  const getAttachments = () => {
    setLoading(true);
    ApiService.get(`list/${itemName}/item/${itemId}/attachments`)
      .then(response => {
        const images = response.data.map(attachment => ({
          src: `${config.serverUrl}/api/attachment/${attachment.key}/thumbnail`,
          placeholder: `${config.serverUrl}/api/attachment/${attachment.key}/thumbnail?resize=60x`,
          ...attachment,
        })).filter(att => hasThumbnail(att.mimeType));

        setSpotlight(images[0]);
        setAttachments(images);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const open = () => {
    window.open(`${config.serverUrl}/api/attachment/${spotlight.key}/download`, '_blank');
  };

  useEffect(() => {
    getAttachments();
  }, []);

  if (!attachments.length) {
    return (
      <div className="mini-gallery empty">
        {loading ? <LoadingPage /> : <div className="empty-msg">No Files Found</div>}
      </div>
    );
  }

  return (
    <div className="mini-gallery">
      <div className="spotlight effect7">
        <MiniImage
          key={spotlight.id}
          src={spotlight.src}
          placeholder={spotlight.placeholder}
          alt={spotlight.filename}
        />
        <div className="spotlight-toolbar">
          {/* <div className="icon" onClick={download}>
            <i className="fas fa-download" />
          </div> */}
          <div className="icon" onClick={open}>
            <i className="fas fa-external-link-alt" />
          </div>
        </div>
      </div>
      <div className="secondary">
        {attachments.map(att => (
          <div
            className={classNames('secondary-wrapper', { active: att.id === spotlight.id })}
            key={att.id}
            onClick={() => setSpotlight(att)}
          >
            <MiniImage src={att.placeholder} alt={att.filename} />
          </div>
        ))}
      </div>
    </div>
  );
};

MiniGallery.propTypes = {
  itemName: PropTypes.string,
  itemId: PropTypes.string,
};

export default MiniGallery;
